export const image1 = require('./carousel/img1.jpg');
export const image2 = require('./carousel/img2.jpg');

export const mockup_1_enchanged = require('./mockup/mockup_1_enchanged.png');
export const worldFlagsOutside = require('./other/world_flags_outside.jpg')

export const increase = require('./banking/increase.png')
export const audit = require('./banking/audit.png')
export const magnet = require('./banking/magnet.png')